const dashboard = {
  title: 'Dashboard',
  welcome: 'Welcome back',
  no_data: 'No results found',
  no_data_description: 'No data available at this time',
};

export default dashboard;
